import React from 'react';
import {Route, Routes} from 'react-router-dom';
import {CATALOG_ROUTE} from '../util/Constants';
import MainLayout from '../layouts/MainLayout';
import ShopRoutesWithModal from './ShopRoutesWithModal';
import {observer} from 'mobx-react-lite';

const AppRouter = observer(() => {
    return (
        <Routes>
            <Route path={CATALOG_ROUTE} element={<MainLayout/>}>
                {/*
                  Корень `/` не всегда матчится вложенным `path="*"` (остаток пути пустой) —
                  без index Outlet пустой и лендинг не показывается.
                */}
                <Route index element={<ShopRoutesWithModal/>}/>
                <Route path="*" element={<ShopRoutesWithModal/>}/>
            </Route>
        </Routes>
    );
});

export default AppRouter;
